import { render, staticRenderFns } from "./EmptyCategory.vue?vue&type=template&id=5233c43f&scoped=true&"
import script from "./EmptyCategory.vue?vue&type=script&lang=js&"
export * from "./EmptyCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5233c43f",
  null
  
)

export default component.exports